/**
 * Firebase_lite.js — re-uses the main CMS Firebase instance.
 * Lite operates on the same Firebase project as the rest of the CMS.
 */
import firebase from "../../Firebase";

export default firebase;
